module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"br":{"title":"Soluções","home":"Home","related_applications":"Aplicações Relacionadas"},"en":{"title":"Solutions","home":"Home","related_applications":"Related Applications"},"es":{"title":"Soluciones","home":"Inicio","related_applications":"Aplicaciones Relacionadas"}}')
  delete Component.options._Ctor
}
